
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlets/[friendlyPath]/[storeFriendlyPath]",
      function () {
        return require("private-next-pages/outlets/[friendlyPath]/[storeFriendlyPath].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlets/[friendlyPath]/[storeFriendlyPath]"])
      });
    }
  